/*=========================================================================================
  File Name: usersActions.js
  Description: Vuex Store - users actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    getShopCategories({commit}, lang_id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/shop/categories/' + lang_id, method: 'GET'})
                .then(({data}) => {
                    commit('SET_PERMISSIONS', data.permissions);
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    /**
     *
     * @returns {Promise<unknown>}
     */
    createShopCategory({commit}, payload) {
        return new Promise((resolve, reject) => {
            let params = payload.lang_id;
            if(payload.category_id) {
                params = payload.lang_id + '/' + payload.category_id
            }

            axios({url: state.API_URL + '/auth/shop/categories/create/' + params, method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    storeShopCategory({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/shop/categories/store', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param id
     * @returns {Promise<unknown>}
     */
    editShopCategory({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/shop/categories/edit/' + id, method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    updateShopCategory({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({
                url: state.API_URL + '/auth/shop/categories/update/' + payload.id,
                data: payload.data,
                method: 'POST'
            })
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param id
     * @returns {Promise<unknown>}
     */
    deleteShopCategory({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/shop/categories/delete/' + id, method: 'DELETE'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    /**
     *
     * @param payload
     * @returns {Promise<unknown>}
     */
    reorderShopCategories({}, payload) {
        return new Promise(() => {
            axios({url: state.API_URL + '/auth/shop/categories/reorder', data: payload, method: 'POST'});
        })
    },
};
